import { api } from "../api";

export async function getCurrentUser() {
  try {
    return await api.getCurrentUser();
  } catch {
    // 401/мережа → неавторизований
    return null;
  }
}

export async function logout() {
  try {
    await api.logout();
  } catch {
    // навіть якщо запит не пройшов — локально виходимо
  }
}
